module.exports = __webpack_public_path__ + "static/media/logo.17c2994b.png";